import { createAction, props } from '@ngrx/store';

import { ReportDetailsUserActionTypes } from '../models';

export const openReportDetailsPage = createAction(
    ReportDetailsUserActionTypes.openReportDetailsPage,
    props<{ reportId: string }>(),
);

export const openKpiSetDetailsPage = createAction(
    ReportDetailsUserActionTypes.openKpiSetDetailsPage,
    props<{ reportId: string }>(),
);

export const activateRecurringReport = createAction(
    ReportDetailsUserActionTypes.activateRecurringReport,
    props<{ reportId: string }>(),
);

export const publishOneOffReport = createAction(
    ReportDetailsUserActionTypes.publishOneOffReport,
    props<{ reportId: string }>(),
);

export const editReportDefinition = createAction(
    ReportDetailsUserActionTypes.editReportDefinition,
    props<{ id: string; name: string; description: string }>(),
);

export const deleteReport = createAction(
    ReportDetailsUserActionTypes.deleteReport,
    props<{ reportId: string }>(),
);

export const printReport = createAction(
    ReportDetailsUserActionTypes.printReport,
    props<{ isPrinting: boolean }>(),
);
